/* AllHealthHousehold — language (auto translation) + currency (display conversion) switchers. */
(function () {
  if (window.btfLocaleInit) return;
  window.btfLocaleInit = true;

  var root = document.querySelector('[data-btf-locale]');
  if (!root) return;
  var isBot = navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|google|bing|yandex|baidu|duckduck/i.test(navigator.userAgent);
  var design = window.Shopify && window.Shopify.designMode;
  var STORE = root.dataset.storeCurrency || 'USD';

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  /* ---------- Put the switcher in the header, next to the cart ---------- */
  function place() {
    /* Fixed bottom-right, directly under <body> so header scripts never move or hide it */
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.classList.add('btf-locale--float');
    root.hidden = false;
    root.removeAttribute('hidden');
  }

  /* Keep logo, prices and the switcher itself out of translation */
  function protect() {
    document.querySelectorAll('.header-logo, .price, [class*="price"], .money, .btf-locale, .btf-bundle__tier strong, .rating-text').forEach(function (el) {
      el.classList.add('notranslate');
      el.setAttribute('translate', 'no');
    });
  }

  /* ---------------- Language ---------------- */
  var langSel = root.querySelector('[data-btf-lang]');
  var LANGS = langSel ? Array.prototype.map.call(langSel.options, function (o) { return o.value; }) : [];

  function getCookieLang() {
    var m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
    if (!m) return 'en';
    var parts = decodeURIComponent(m[1]).split('/');
    return parts[2] || 'en';
  }
  function setCookieLang(lang) {
    var host = location.hostname.replace(/^www\./, '');
    var exp = lang === 'en' ? '; expires=Thu, 01 Jan 1970 00:00:00 GMT' : '';
    var val = 'googtrans=/en/' + lang + exp + '; path=/';
    document.cookie = val;
    document.cookie = val + '; domain=.' + host;
  }
  function browserLang() {
    var list = navigator.languages || [navigator.language || 'en'];
    for (var i = 0; i < list.length; i++) {
      var l = String(list[i]);
      if (/^zh-(TW|HK|Hant)/i.test(l)) return 'zh-TW';
      if (/^zh/i.test(l)) return 'zh-CN';
      if (/^(he|iw)/i.test(l)) return 'iw';
      if (/^(nb|nn|no)/i.test(l)) return 'no';
      if (/^fil/i.test(l)) return 'tl';
      var base = l.split('-')[0].toLowerCase();
      if (LANGS.indexOf(base) > -1) return base;
    }
    return 'en';
  }
  function loadTranslator() {
    window.btfGTInit = function () {
      try {
        new window.google.translate.TranslateElement({ pageLanguage: 'en', includedLanguages: LANGS.join(','), autoDisplay: false }, 'btf_gt');
      } catch (e) {}
    };
    var s = document.createElement('script');
    s.src = 'https://translate.google.com/translate_a/element.js?cb=btfGTInit';
    s.async = true;
    document.head.appendChild(s);
  }

  if (langSel) {
    var current = getCookieLang();
    if (!ls('btf_lang_auto') && !isBot && !design) {
      ls('btf_lang_auto', '1');
      var auto = browserLang();
      if (auto !== 'en' && current === 'en') { setCookieLang(auto); current = auto; }
    }
    langSel.value = LANGS.indexOf(current) > -1 ? current : 'en';
    document.documentElement.classList.toggle('btf-rtl', current === 'ar');
    if (current !== 'en' && !isBot) loadTranslator();
    langSel.addEventListener('change', function () {
      ls('btf_lang_auto', '1');
      setCookieLang(langSel.value);
      location.reload();
    });
  }

  /* ---------------- Currency ---------------- */
  var curSel = root.querySelector('[data-btf-cur]');
  var TZ = {
    'Asia/Amman': 'JOD', 'Asia/Riyadh': 'SAR', 'Asia/Dubai': 'AED', 'Asia/Qatar': 'QAR', 'Asia/Kuwait': 'KWD', 'Asia/Bahrain': 'BHD',
    'Asia/Muscat': 'OMR', 'Africa/Cairo': 'EGP', 'Europe/Istanbul': 'TRY', 'Asia/Kolkata': 'INR', 'Asia/Calcutta': 'INR', 'Asia/Tokyo': 'JPY',
    'Asia/Seoul': 'KRW', 'Asia/Shanghai': 'CNY', 'Asia/Hong_Kong': 'HKD', 'Asia/Singapore': 'SGD', 'Europe/London': 'GBP', 'Europe/Zurich': 'CHF',
    'Europe/Stockholm': 'SEK', 'Europe/Oslo': 'NOK', 'Europe/Copenhagen': 'DKK', 'Europe/Warsaw': 'PLN', 'America/Mexico_City': 'MXN',
    'America/Sao_Paulo': 'BRL', 'Africa/Johannesburg': 'ZAR', 'Australia/Sydney': 'AUD', 'Australia/Melbourne': 'AUD', 'Australia/Brisbane': 'AUD',
    'Australia/Perth': 'AUD', 'Pacific/Auckland': 'NZD', 'America/Toronto': 'CAD', 'America/Vancouver': 'CAD', 'America/Edmonton': 'CAD',
    'America/Winnipeg': 'CAD', 'America/Halifax': 'CAD'
  };
  var EURO = /^Europe\/(Paris|Berlin|Madrid|Rome|Amsterdam|Brussels|Vienna|Dublin|Lisbon|Helsinki|Athens|Luxembourg|Bratislava|Ljubljana|Tallinn|Riga|Vilnius|Valletta|Nicosia|Zagreb|Monaco|Andorra)$/;
  var REGION = { GB: 'GBP', CA: 'CAD', AU: 'AUD', NZ: 'NZD', AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD', BH: 'BHD', OM: 'OMR', JO: 'JOD', EG: 'EGP',
    TR: 'TRY', IN: 'INR', JP: 'JPY', KR: 'KRW', CN: 'CNY', HK: 'HKD', SG: 'SGD', CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', MX: 'MXN',
    BR: 'BRL', ZA: 'ZAR', DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR', IE: 'EUR', PT: 'EUR', FI: 'EUR', GR: 'EUR' };

  function guessCurrency() {
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (TZ[tz]) return TZ[tz];
    if (EURO.test(tz)) return 'EUR';
    var list = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < list.length; i++) {
      var r = String(list[i]).split('-')[1];
      if (r && REGION[r.toUpperCase()]) return REGION[r.toUpperCase()];
    }
    return STORE;
  }

  var rates = null;
  var target = STORE;
  var done = new WeakMap();
  var RX = /(?:US)?\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(?:\s?USD)?/g;

  function fmt(v) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: target, maximumFractionDigits: /JPY|KRW|VND|IDR|CLP|ISK|UYU|COP|HUF/.test(target) ? 0 : 2 }).format(v);
    } catch (e) { return target + ' ' + v.toFixed(2); }
  }
  function convertNode(node) {
    var rec = done.get(node);
    if (rec && node.nodeValue === rec.out) return;
    var orig = rec && node.nodeValue === rec.out ? rec.orig : node.nodeValue;
    if (!/\$/.test(orig)) return;
    var out = target === STORE ? orig : orig.replace(RX, function (m, num) {
      var usd = parseFloat(num.replace(/,/g, ''));
      if (isNaN(usd)) return m;
      return fmt(window.Currency.convert(usd * 100, STORE, target) / 100);
    });
    done.set(node, { orig: orig, out: out });
    if (out !== node.nodeValue) node.nodeValue = out;
  }
  var PRICE_SEL = '.price, [class*="price"], .money, [class*="total"], [class*="subtotal"], .btf-similar__price, .cart-item__price, .free-shipping-bar';
  function convertAll() {
    if (!rates) return;
    document.querySelectorAll(PRICE_SEL).forEach(function (el) {
      if (el.closest('.btf-locale, script, style, select')) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) convertNode(n);
    });
    note();
  }
  function restoreAll() {
    document.querySelectorAll(PRICE_SEL).forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var rec = done.get(n);
        if (rec && n.nodeValue === rec.out) n.nodeValue = rec.orig;
        done.delete(n);
      }
    });
  }
  function note() {
    document.querySelectorAll('.cart-page__summary, .cart-drawer__summary').forEach(function (box) {
      var el = box.querySelector('.btf-cur-note');
      if (target === STORE) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'btf-cur-note';
        box.insertBefore(el, box.firstChild);
      }
      var txt = 'Prices shown in ' + target + ' are estimates. You will be charged in ' + STORE + ' at checkout.';
      if (el.textContent !== txt) el.textContent = txt;
    });
  }
  var rateWaiters = null;
  function loadRates(cb) {
    if (window.Currency && window.Currency.rates) { rates = window.Currency.rates; return cb(); }
    if (rateWaiters) { rateWaiters.push(cb); return; }
    rateWaiters = [cb];
    var s = document.createElement('script');
    s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    s.async = true;
    s.onload = function () {
      if (window.Currency && window.Currency.rates) {
        rates = window.Currency.rates;
        Array.prototype.forEach.call(curSel.options, function (o) { if (!rates[o.value]) o.hidden = true; });
        var list = rateWaiters; rateWaiters = null;
        list.forEach(function (f) { f(); });
      }
    };
    document.head.appendChild(s);
  }

  if (curSel) {
    /* Currency is never switched automatically: store currency until the customer picks one */
    target = ls('btf_cur2') || STORE;
    curSel.value = target;
    if (curSel.value !== target) { target = STORE; curSel.value = STORE; }
    var observing = false;
    function activate() {
      loadRates(function () {
        if (!rates[target]) { target = STORE; curSel.value = STORE; }
        convertAll();
        if (!observing && window.MutationObserver) {
          observing = true;
          var t;
          new MutationObserver(function () { if (target === STORE) return; clearTimeout(t); t = setTimeout(convertAll, 150); })
            .observe(document.body, { childList: true, subtree: true, characterData: true });
        }
      });
    }
    /* Rates are only downloaded when a customer actually uses another currency (keeps pages fast) */
    if (target !== STORE) {
      if ('requestIdleCallback' in window) requestIdleCallback(activate, { timeout: 2500 }); else setTimeout(activate, 800);
    }
    curSel.addEventListener('focus', function () { loadRates(function () {}); }, { once: true });
    curSel.addEventListener('change', function () {
      ls('btf_cur2', curSel.value);
      restoreAll();
      target = curSel.value;
      activate();
    });
  }

  function start() { place(); protect(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
